import Toastr from '../../../../../../itrust_common/components/Toastr'

const DEFAULT_STATE = {
  saving: false,
  diagnosis_codes: [],
  procedure_codes: [],
  registered_labs: [],
  len_design: [],
  len_treatment: [],
  treatment_saving: false,
}

const getVersantCodes = (payload) => {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []
  if (Array.isArray(payload.responseObject)) return payload.responseObject
  if (Array.isArray(payload.data)) return payload.data
  return []
}

let changes = null

export const versantReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'VERSANT_DIAGNOSIS_CODES_LOAD_PENDING':
    case 'VERSANT_PROCEDURE_CODES_LOAD_PENDING':
    case 'VERSANT_REGISTERED_LABS_LOAD_PENDING':
    case 'VERSANT_LEN_DESIGN_LOAD_PENDING':
      return { ...state, saving: true }

    case 'VERSANT_DIAGNOSIS_CODES_LOAD_REJECTED':
    case 'VERSANT_PROCEDURE_CODES_LOAD_REJECTED':
    case 'VERSANT_REGISTERED_LABS_LOAD_REJECTED':
    case 'VERSANT_LEN_DESIGN_LOAD_REJECTED':
      Toastr.handleShow(false, response.data.error, response.data.status)
      changes = { saving: false }
      return { ...state, ...changes }

    case 'VERSANT_DIAGNOSIS_CODES_LOAD_FULFILLED':
      changes = {
        diagnosis_codes: getVersantCodes(response?.diagnosis_codes || response),
        saving: false,
      }
      return { ...state, ...changes }

    case 'VERSANT_PROCEDURE_CODES_LOAD_FULFILLED':
      changes = {
        procedure_codes: getVersantCodes(response?.procedure_codes || response),
        saving: false,
      }
      return { ...state, ...changes }

    case 'VERSANT_REGISTERED_LABS_LOAD_FULFILLED':
      changes = {
        registered_labs: getVersantCodes(response?.registered_labs || response),
        saving: false,
      }
      return { ...state, ...changes }

    case 'VERSANT_LEN_TREATMENT_LOAD_PENDING':
      return { ...state, treatment_saving: true }

    case 'VERSANT_LEN_TREATMENT_LOAD_REJECTED':
      Toastr.handleShow(false, response.data.error, response.data.status)
      return { ...state, treatment_saving: false }

    case 'VERSANT_LEN_TREATMENT_LOAD_FULFILLED':
      return {
        ...state,
        len_treatment: getVersantCodes(response?.len_treatment || response),
        treatment_saving: false,
      }

    case 'VERSANT_LEN_DESIGN_LOAD_FULFILLED':
      changes = {
        len_design: getVersantCodes(response?.len_design || response),
        saving: false,
      }
      return { ...state, ...changes }

    default:
      return state
  }
}
